<template>
  <div>
    <ModuleHeader>Reglas de disponibilidad de producto</ModuleHeader>
    <DataTable :config="config" :data="rulesAvailability" :pageRows="15" @buttonClick="dtButtonClick">
    </DataTable>

    <modal v-model="showModal" :key="formIndex" :fullscreen="true" :disableScroll="true" :showFooter="false"
      :title="titleModal">
      <RulesAvailabilityForm :dataEdit="dataEdit" @successData="getSuccessData" @toggle="toggleModal" />
    </modal>
  </div>
</template>

<script>

import DataTable from "../../MainComponents/DataTable.vue";
import RulesAvailabilityForm from "./RulesAvailabilityForm.vue";
export default {
  name: "RulesAvailability",
  components: {
    RulesAvailabilityForm,
    DataTable,
  },
  data() {
    return {
      rulesAvailability: [],

      formIndex: 1,
      showModal: false,
      dataEdit: [],
      editMode: false,

      titleModal: "",

      config: {
        selectableRow: true,
        allowExport: false,
        rawText: "Reglas de disponibilidad",
        orderByCol: { Field: "nombreZona", Type: "Asc" },
        selectConfig: {
          idRowData: "id",
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addRule",
            require: false,
          },


        ],
        fields: [
          {
            text: "Nombre",
            value: "cd",
          },
          {
            text: "Descripción",
            value: "ds",
          },
          {
            text: "Vigencia",
            value: "vigenciaFormateada",
          },
          {
            text: "Total Crons",
            value: "totalCrons",
          },
          {
            text: "Total Inclusiones",
            value: "totalInclusiones",
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "editar",
                buttonId: "editRule",
                value: "id",
              },
              {
                color: "red",
                text: "Eliminar",
                buttonId: "deleteRule",
                value: "id",
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addRule") {
        this.titleModal = "Añadir Regla de disponibilidad";
        this.showForm();
      }
      if (buttonId == "editRule") {
        this.titleModal = "Editar Regla de disponibilidad";
        this.showEditForm(idSelected);
      }
      if (buttonId == "deleteRule") {
        this.deleteRule(idSelected);
      }
    },
    async getRulesAvailability() {
      this.rulesAvailability = [];

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let data = await firestore.queryBuilder("PDV_ReglasDisponibilidad", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where(
          "Dlat",
          "==",
          null
        ),
      ]);
      let document = data.docs.map((doc) => {
        let d = doc.data();
        let vigencia = "Permanente";
        if (d.vg && d.vg.in) {
          vigencia = d.vg.in + (d.vg.tm ? ' a ' + d.vg.tm : ' (Sin término)');
        }

        let totalCrons = d.rg ? d.rg.length : 0;
        let totalInclusiones = d.in ? d.in.length : 0;

        return {
          id: doc.ref.id,
          ...d,
          vigenciaFormateada: vigencia,
          totalCrons: totalCrons,
          totalInclusiones: totalInclusiones
        };
      });
      this.rulesAvailability = document;

    },

    showForm() {
      this.formIndex++;
      this.editMode = false;
      this.dataEdit = false;
      this.showModal = true;
    },
    showEditForm(id) {
      this.formIndex++;
      this.editMode = true;
      this.dataEdit = this.$pgsHelper.getById(this.rulesAvailability, "id", id);
      this.showModal = true;
    },

    toggleModal(open) {
      this.showModal = open;
    },
    getSuccessData(data) {


      if (data.edit == "" || !data.edit) {
        this.save(data);
      } else {
        //dataAcceso.id = data.id;
        this.edit(data);
      }
    },

    save(data) {
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas guardar esta regla de disponibilidad?",
        text: "La regla de disponibilidad se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-createReglaDisponibilidad", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Regla de disponibilidad guardada",
              "La regla de disponibilidad se almaceno correctamente",
              "success"
            );
            this.getRulesAvailability();
            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    edit(data) {
      this.$pgsHelper.log("data", data);
      data.Id = data.id

      this.$swal({
        title: "¿Deseas editar esta regla de disponibilidad?",
        text: "La regla de disponibilidad se guardara con los datos especificados",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-updateReglaDisponibilidad", data)
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Regla de disponibilidad guardada",
              "La regla de disponibilidad se almaceno correctamente",
              "success"
            );
            this.getRulesAvailability();
            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteRule(id) {

      this.$swal({
        title: "¿Deseas eliminar esta regla de disponibilidad?",
        text: "Se eliminará su información permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-deleteReglaDisponibilidad", { Id: id })
            .then((result) => {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Regla de disponibilidad eliminada",
              "La regla de disponibilidad se elimino correctamente",
              "success"
            );
            this.getRulesAvailability();
          } else {
            this.$swal(
              "Error al eliminar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });

    },
  },
  async mounted() {
    await this.getRulesAvailability();
  },
};
</script>
